<template>
    <div id="mnemonicWord">
        <mt-header class="dl_header_new_bg" fixed title>
            <mt-button slot="left" @click="backAndDelete">
                <img class="go-back" src="@/assets/img/ico_back.png" />
            </mt-button>
        </mt-header>
        <div class="container">
            <h2 class="page-title" style="font-weight: bold;">{{ $t('mnemonic.title3') }}</h2>

            <div class="content">
                <div class="swiper">
                    <p class="wx_fontSize2">{{ $t('mnemonic.tip3_1') }}</p>
                    <!-- <p class="wx_fontSize2">{{$t('mnemonic.tip3_2')}}</p> -->
                </div>
                <ul class="table clearfix">
                    <li v-for="(item, index) in list" class="wx_fontSize3" :key="index">
                        <mt-badge size="small">{{ index + 1 }}</mt-badge>
                        {{ item }}
                    </li>
                </ul>
                <div class="footer wx_fontSize3" @click="backupTip()">{{ $t('mnemonic.save') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Indicator } from "mint-ui";
import { validateEmpty } from "@/utils/validate";
import { createUniqueString } from "@/utils/index";
import { generateAddress,generateSingleAddress } from "@/utils/hdwallet";
import { httpList, httpCreate, httpInit } from "@/api/hdwallet";
export default {
    data() {
        return {
            list: [],
            ethAddress: "",
            btcAddress: "",
            wallets: null,
            isFirstWallet:false,
        };
    },
    methods: {
        backupTip() {
            if (validateEmpty(this.$store.state.hdtoken)) {
                this.$router.push("/safety");
                //this.createHdWallet();
            } else {
                this.$router.push('/')
            }

        },
        createHdWallet: function () {
            return httpCreate({ primary_key: createUniqueString() })
                .then(res => {
                    this.$store.dispatch("setHdToken", res.data.hd_token);
                    this.initHdWallet();
                })
                .catch(() => { });
        },
        initHdWallet: function () {
            return httpInit({ BTC: this.btcAddress, ETH: this.ethAddress })
                .then(res => {
                    this.$router.push("/safety");
                    //this.getLocalData();
                })
                .catch(() => { });
        },
        generateHdAddress: async function () {
            if (validateEmpty(window.LS.get("mnemonic"))) {
                this.isFirstWallet = true
                this.$store.dispatch('setIsFirstWallet',true)
                let result = await generateAddress(this.walletPassword);
                console.log(result);
                this.wallets = result.wallets
                this.ethAddress = result.ethAddress;
                this.btcAddress = result.btcAddress;
                this.list = result.mnemonic.split(" ");
            } else {
                  let result = await generateSingleAddress(this.walletPassword,this.$route.query.chain,this.walletName);
                console.log(result);
                this.wallets = result.wallets
                this.list = result.mnemonic.split(" ");
            }
        },

        backAndDelete(){
            console.log(this.isFirstWallet)
            if(this.isFirstWallet){
                let wallets = (window.LS.get(`wallets`))
                if (wallets) {
                    wallets = JSON.parse(window.LS.get(`wallets`))
                    wallets.forEach(w => {
                        window.localStorage.removeItem(`w-${w}`)
                    })
                }
                window.localStorage.removeItem(`mnemonic`)

                window.localStorage.removeItem(`wallets`)
            }
            this.$store.dispatch('setIsFirstWallet',false)

            this.$router.push('/')
        }
    },
    computed: {
        walletPassword: {
            get() {
                return this.$store.getters.hdWalletPassword
            }
        },

          walletName: {
            get() {
                return this.$store.getters.hdWalletName
            }
        },

        
     
    },
    mounted: function () { },
    activated() {
        this.generateHdAddress();
    }
};
</script>

<style scoped>
* {
    box-sizing: border-box;
}

#mnemonicWord {
    width: 100%;
    min-height: 100%;
    background-color: #F6F8FA;
    /* background-image: url('../../assets/img/index/bg_bendi_home.png'); */
}

/* .mint-header {
  background: transparent;
} */
.backG {
    width: 100%;
    height: 100%;
}

.go-back {
    width: 20px;
    height: 20px;
}

.page-title {
    font-size: 1.125rem;
    font-weight: 600;
    margin-top: 60px;
    margin-bottom: 10px;
}

.mark {
    width: 86%;
    margin-left: 7%;
    padding-top: 50px;
    height: 36%;
}

.container {
    width: 100%;
    padding: 0 30px;

}

#mnemonicWord .content {
    width: 100%;
    height: 100%;
    /* position: relative;
  top: 0; */
    background-color: #fff;
    padding: 20px 10px !important;
    border-radius: 20px;
    box-shadow: 0 20px 15px 8px #DAE5F0;

}

.swiper {
    border-radius: 10px;
    color: #12172E;
    padding: 10px;
}

.swiper p {
    margin: 25px 5px;
}

.table {
    padding: 0px 15px 20px 15px;
    margin: 0 auto;
}

.table li {
    width: calc((100% / 3) - 3px);
    height: 50px;
    float: left;
    text-align: center;
    color: #12172E;
    border: 0.5px solid #12172E;
    line-height: 50px;
    position: relative;
}

.footer {
    width: 80%;
    height: 50px;
    background: #2BB0E9;
    line-height: 50px;
    text-align: center;
    color: #fff;
    border-radius: 50px;
    position: relative;
    margin: 20px auto;
}

.mint-badge.is-primary {
    background: transparent;
    position: absolute;
    top: -10px;
    left: 5px;
    color: #A9AFBD;
}
</style>